import { HttpService } from "@/core";
export const post = () => {
  const api = (url, data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url,
      data,
    });
  return HttpService.useRequest<any>(api);
};
export const get = () => {
  const api = (url, params: any = {}) =>
    HttpService.axios({
      method: "GET",
      url,
      params,
    });
  return HttpService.useRequest<any>(api);
};
